import {
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  MenuItem,
  Select,
} from "@mui/material";
import { statecityData } from "../../shared/enums";
import Spinner from "../assets/icons/Spinner";

import { Checkbox, ListItemText } from "@mui/material";
import { DropDown, DropUpArrow } from "../assets/icons/index";
import React, { useEffect, useState } from "react";
import CustomInput from "../utils/Input";
import Progress from "../utils/RangeFilter";
import style from "../../components/RFPDashboard/CampaignDetails/Campaign.module.css";
import axios from "axios";
import styles from "../../styles/mapFilterModal.module.css";
import GlobalButton from "../utils/GlobalButton";
const productOptions = [
  {
    value: "fabrication:Glow Sign Boards",
    label: "Glow Sign Boards",
  },
  {
    value: "fabrication:ACP Sign Board",
    label: "ACP Sign Board",
  },
  {
    value: "fabrication:Lollipop Signage",
    label: "Lollipop Signage",
  },
  { value: "fabrication:3D Signage", label: "3D Signage" },

  {
    value: "fabrication:Aluminum Backlit Signage",
    label: "Aluminum Backlit Signage",
  },
  { value: "fabrication:Flex Frame Signage", label: "Flex Frame Signage" },
  { value: "printing:Solvent Print", label: "Solvent Print" },
  {
    value: "printing:Eco Solvent Print",
    label: "Eco Solvent Print",
  },
  { value: "printing:UV Printing", label: "UV Printing" },
  { value: "printing:Latex Printing", label: "Latex Printing" },
  {
    value: "printing:Plotter Cut",
    label: "Plotter Cut",
  },
  { value: "printing:Vinyl Branding", label: "Vinyl Branding" },
  { value: "printing:POS", label: "POS" },
];
const MapFilterModal = ({
  filterModal,
  setFilterModal,
  // getVendorList,
  isRadarLoading,
  setIsRadarLoading,
  setVendors,
  filterData,
  setFilterData,
  vendors,
  machinesNeededForPrinting,
  centerPoint,
  isLoadingClusters,
  setCenterPoint,
  machinesNeededForFabrication,
  availableJobs = [],
  availableClusters = [],
  // campaignLocations = [],
}) => {
  let campaignLocations = availableClusters
    ?.filter((cluster) => !cluster.vendorId)
    ?.map((cluster) => {
      let cities = new Set(); // Using a Set to avoid duplicate city names

      cluster.batches.forEach((batch) => {
        batch.jobs.forEach((job) => {
          cities.add(job.city);
        });
      });

      return {
        id: cluster._id,
        name: cluster.clusterTitle,
        cities: Array.from(cities), // Convert Set to Array
        productType: cluster.productType,
        location: cluster.centroidCoordinates,
      };
    });
  const [filteredLocations, setFilteredLocations] = useState(campaignLocations);
  const [searchQuery, setSearchQuery] = useState("");
  const [openSection, setOpenSection] = useState(null); // Tracks the main accordion section
  const [opencertSection, setOpenCertSection] = useState(null); // Tracks the main accordion section
  const [locationSection, setLocationSection] = useState("location");
  const [selectedFabricationTypes, setSelectedFabricationTypes] = useState([]);
  const [reliabilitySection, setRealiablitySection] = useState(null);
  const [distanceSection, setDistanceSection] = useState(null);
  const [creditSection, setCreditSection] = useState(null);
  const [manpowerSection, setManpowerSection] = useState(null);
  const [premisesSection, setPremisesSection] = useState(null);
  const [fabricationMachineSection, setFabricationMachineSection] =
    useState(null);
  const [printingMachineSection, setPrintingMachineSection] = useState(null);
  const [selectSection, setSelectionSelection] = useState(null);
  const [certSection, setCertSelection] = useState(null);
  const [selectedCerts, setSelectedCerts] = useState([]);
  // const [maxValue, setMaxValue] = React.useState(500); // Dynamic max value
  // const [value, setValue] = React.useState([
  //   filterData?.minValueKms,
  //   filterData?.maxValueKms,
  // ]);
  const [useFabricationMachinesForFilter, setUseFabricationMachinesForFilter] =
    React.useState(filterData.checkMachinesForFabrication);
  const [usePrintingMachinesForFilter, setUsePrintingMachinesForFilter] =
    React.useState(filterData.checkMachinesForPrinting);
  const [totalVendors, setTotalVendors] = useState("0");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const serverURL = process.env.REACT_APP_URL;

  const handleClose = () => {
    setFilterModal(false);
  };
  const handleInputChangeState = (e) => {
    const { name, value } = e.target;
    if (name === "selectedState" || name === "selectedCity") {
      setFilterData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle input change to filter the locations
  const handleInputChangeLoc = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Filter locations based on search query
    const updatedLocations = campaignLocations.filter((location) =>
      location.name.toLowerCase().includes(query.toLowerCase()),
    );

    setFilteredLocations(updatedLocations);
  };
  const handleInputChange = (event) => {
    const { name, value, checked } = event.target;
    setFilterData((prevData) => ({
      ...prevData,
      [name]:
        name === "checkMachinesForPrinting"
          ? checked
          : name === "checkMachinesForFabrication"
            ? checked
            : value, // Dynamically update reliability field in filterData
    }));
  };
  const [cityArray, setCityArray] = useState([]);

  // Tracks the nested subsection
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  const toggleCertSection = (section) => {
    setOpenCertSection(opencertSection === section ? null : section);
  };
  const locationSectionToggle = (section) => {
    if (locationSection === section) {
      setLocationSection("");
    } else {
      setLocationSection(section);
    }
  };
  const relabilityToogle = (section) => {
    setRealiablitySection(reliabilitySection === section ? null : section);
  };
  const distanceToogle = (section) => {
    setDistanceSection(distanceSection === section ? null : section);
  };
  const creditToogle = (section) => {
    setCreditSection(creditSection === section ? null : section);
  };
  const manpowerToogle = (section) => {
    setManpowerSection(manpowerSection === section ? null : section);
  };
  const premisesToogle = (section) => {
    setPremisesSection(premisesSection === section ? null : section);
  };
  const fabricationMachineToggle = (section) => {
    setFabricationMachineSection(
      fabricationMachineSection === section ? null : section,
    );
  };
  const printingMachineToggle = (section) => {
    setPrintingMachineSection(
      printingMachineSection === section ? null : section,
    );
  };
  const selectToogle = (section) => {
    setSelectionSelection(selectSection === section ? null : section);
  };

  const selectCertToogle = (section) => {
    setCertSelection(certSection === section ? null : section);
  };

  const handleCheckboxChange = (section, value) => {
    setFilterData((prev) => {
      const currentValue = prev[section];

      // Check if the current value is an array
      if (Array.isArray(currentValue)) {
        // For arrays, handle add/remove logic
        if (currentValue.includes(value)) {
          // If the value is already in the array, remove it
          return {
            ...prev,
            [section]: currentValue.filter((item) => item !== value),
          };
        } else {
          // If the value is not in the array, add it
          return {
            ...prev,
            [section]: [...currentValue, value],
          };
        }
      } else {
        // For single values, toggle boolean
        return {
          ...prev,
          [section]: !currentValue,
        };
      }
    });
  };
  const handleCartCheckboxChange = (cert) => {
    setSelectedCerts((prev) =>
      prev.includes(cert) ? prev.filter((c) => c !== cert) : [...prev, cert],
    );
  };
  const [location, setLocation] = useState("");
  const cityApiKey = process.env.REACT_APP_FETCH_STATE_CITY_API_KEY;

  useEffect(() => {
    const stateCode = statecityData.find(
      (ele) => ele.name === filterData?.selectedState,
    )?.iso2;

    if (filterData?.selectedState && stateCode) {
      const fetchCities = async () => {
        const headers = new Headers();
        headers.append("X-CSCAPI-KEY", cityApiKey);

        const requestOptions = {
          method: "GET",
          headers: headers,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
            requestOptions,
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const cityData = await response.json();
          setCityArray(cityData);
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      fetchCities();
    }
  }, [filterData?.selectedState]);

  useEffect(() => {
    const updatedCampaignLocations = availableClusters
      ?.filter((cluster) => !cluster.vendorId)
      ?.map((cluster) => {
        let cities = new Set();
        cluster.batches.forEach((batch) => {
          batch.jobs.forEach((job) => {
            cities.add(job.city);
          });
        });
        return {
          id: cluster._id,
          name: cluster.clusterTitle,
          cities: Array.from(cities),
          productType: cluster.productType,
          location: cluster.centroidCoordinates,
        };
      });
    setFilteredLocations(updatedCampaignLocations);
  }, [availableClusters]);

  const filterVendors = async (page = 1, limit = 20) => {
    try {
      setIsRadarLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/api/filteredVendorByValues`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            page,
            limit,
            maxValueKms: filterData?.maxValueKms,
            // minValueKms: filterData?.minValueKms,
            creditLimit: filterData.creditLimit,
            reliability: filterData.reliability,
            premises: filterData.premises,
            manpower: filterData.manpower,
            selectedCity: filterData.selectedCity,
            selectedState: filterData.selectedState,

            products:
              filterData.selectedProducts?.length > 0
                ? JSON.stringify(filterData.selectedProducts)
                : undefined,
            machinesNeededForFabrication: machinesNeededForFabrication,
            machinesNeededForPrinting: machinesNeededForPrinting,
            useFabricationMachinesForFilter,
            usePrintingMachinesForFilter,
            certifications:
              selectedCerts.length > 0
                ? JSON.stringify(selectedCerts)
                : undefined,
          },
        },
      );

      if (response?.data?.success) {
        setTotalVendors(response?.data?.totalVendors);
        setVendors(response?.data?.data);
        setCenterPoint(response.data.CenterPoint);
        // setTotalPages(response?.data?.totalPages);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const getVendorList = async (page = 1, limit = 20) => {
    try {
      setIsRadarLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(`${serverURL}/api/filteredVendors`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page,
          limit,
          filteringForClusters: true,
          maxValueKms: filterData?.maxValueKms,
          // minValueKms: filterData?.minValueKms,
          creditLimit: filterData.creditLimit,
          reliability: filterData.reliability,
          premises: filterData.premises,
          manpower: filterData.manpower,

          location: filterData.location,
          products:
            filterData.selectedProducts?.length > 0
              ? JSON.stringify(filterData.selectedProducts)
              : undefined,
          machinesNeededForFabrication: machinesNeededForFabrication,
          machinesNeededForPrinting: machinesNeededForPrinting,
          useFabricationMachinesForFilter,
          usePrintingMachinesForFilter,
          certifications:
            selectedCerts.length > 0
              ? JSON.stringify(selectedCerts)
              : undefined,
        },
      });

      if (response?.data?.success) {
        setTotalVendors(response?.data?.totalVendors);
        setVendors(response?.data?.vendors);
        // setTotalPages(response?.data?.totalPages);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const handleKeyPress = (e) => {
    const { name, type } = e.target;
    const charCode = e.keyCode || e.which;

    if (name === "userName") {
      // Block characters that are not letters or spaces for the name input
      if (/[^a-zA-Z\s]/.test(e.key)) {
        e.preventDefault();
      }
    } else if (type === "number" || name === "phoneNumber") {
      // Block 'e', 'E', '-', '+', and '.' for phone number input
      if ([69, 101, 43, 45, 46].includes(charCode)) {
        e.preventDefault();
      }
    }
  };

  const handleSubmit = () => {
    const page = 1; // Default page number
    const limit = 20; // Default limit

    // Call the function with the correct arguments
    setFilterModal(false);
    setTimeout(() => {
      setIsRadarLoading(true);
      setIsRadarLoading(false);
    }, 5000);
    getVendorList(page, limit);
  };

  // Separate checked locations from the filtered ones
  const checkedLocations = filterData.location.map((locationName) =>
    campaignLocations.find((location) => location.name === locationName.name),
  );
  const remainingLocations = filteredLocations.filter(
    (location) =>
      !filterData.location.some(
        (selectedLocation) => selectedLocation.name === location.name,
      ),
  );

  const handleCheckboxChangeLoc = (e, locationName) => {
    const { checked } = e.target;

    setFilterData((prevData) => {
      let updatedLocations = [...prevData.location];
      if (checked) {
        // If checked, add the location name to the array
        updatedLocations.push(locationName);
      } else {
        // If unchecked, remove the location name from the array
        updatedLocations = updatedLocations.filter(
          (location) => location.name !== locationName.name,
        );
      }

      return {
        ...prevData,
        location: updatedLocations,
      };
    });
  };
  const handleLocationChange = (e) => {
    const { value } = e.target;
    setLocation(value);
  };

  const handleFilterClick = async (e) => {
    const page = 1;
    const limit = 20;

    setFilterModal(false);

    setTimeout(() => {
      setIsRadarLoading(true);
      setIsRadarLoading(false);
    }, 5000);

    filterVendors(page, limit);
  };

  return (
    <Dialog
      open={filterModal}
      className={styles.dialog}
      BackdropProps={{
        className: styles["dialog-backdrop"],
      }}
      onClose={handleClose}
    >
      <DialogContent className={styles["dialog-content"]}>
        {/* Your dialog content here */}
        <div className="border rounded-md py-1 px-2">
          <div
            className="flex justify-between items-center  rounded-md "
            onClick={() => locationSectionToggle("location")}
            style={{
              cursor: "pointer",
              background: "white",
              padding: "2px",
            }}
          >
            <p className="mt-1 mb-1 text-[var(--heading-color)] font-bold">
              Location to be served
            </p>
            <div>
              {locationSection === "location" ? <DropUpArrow /> : <DropDown />}
            </div>
          </div>

          {locationSection === "location" && (
            <>
              {isLoadingClusters ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 100,
                  }}
                >
                  <Spinner color="#1976d2" size="32" />
                </div>
              ) : availableClusters.length === 0 ? (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className="text-[14px]">State *</FormControl>
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        marginTop: "0.5rem",
                      }}
                      // value={formData?.state.name}
                    >
                      <Select
                        inputProps={{
                          "aria-label": "Without label",
                        }}
                        displayEmpty
                        value={filterData?.selectedState}
                        name="selectedState"
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#b0b0b0", // Set border color
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#b0b0b0", // Keep border color on focus
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#b0b0b0", // Keep border color on hover
                          },
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": {
                              borderColor: "#b0b0b0", // Ensure hover state is consistent
                            },
                            marginTop: "0.5rem",
                          },
                        }}
                        // value={formData?.state.name}
                        onChange={handleInputChangeState}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <p className="text-[1rem] text-[var(--light-gray)]">
                                Select State
                              </p>
                            );
                          }

                          return selected;
                        }}
                      >
                        {statecityData.map((state) => (
                          <MenuItem key={state.name} value={state.name}>
                            {state.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} sx={{ marginTop: 1 }}>
                    <FormControl className="text-[14px] mt-10 ml-2">
                      City *
                    </FormControl>
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        marginTop: "0.2rem",
                      }}
                    >
                      <Select
                        value={filterData?.selectedCity} // <-- This is important!
                        onChange={handleInputChangeState}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        name="selectedCity"
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#b0b0b0",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#b0b0b0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#b0b0b0",
                          },
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": {
                              borderColor: "#b0b0b0",
                            },
                            marginTop: "0.5rem",
                          },
                        }}
                        renderValue={(selected) =>
                          selected ? (
                            selected
                          ) : (
                            <p className="text-[1rem] text-[var(--light-gray)]">
                              Select City
                            </p>
                          )
                        }
                      >
                        {cityArray.map((city) => (
                          <MenuItem key={city.name} value={city.name}>
                            {city.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              ) : (
                <>
                  <CustomInput
                    className="text-xs font-medium leading-6 text-left"
                    placeholder="Search Location"
                    type="text"
                    size="small"
                    // disabled
                    name="location"
                    customcolor="var(--heading-color)"
                    fontWeight="500"
                    onChange={handleInputChangeLoc}
                  />
                  <div
                    className={`max-h-[200px] overflow-y-scroll ${style["custom-scrollbar"]}`}
                  >
                    {checkedLocations.length > 0 && (
                      <div>
                        {checkedLocations.map((ele, index) => (
                          <div
                            className="gap-2 flex ml-4 items-baseline py-1"
                            key={index}
                          >
                            <input
                              type="checkbox"
                              checked={true} // Always checked for the selected location
                              onChange={(e) => handleCheckboxChangeLoc(e, ele)} // Handle checkbox change
                            />
                            <span className="flex flex-col px-1 cursor-pointer">
                              <label> {ele.name}</label>
                              <label className="opacity-50 pl-2">
                                {ele.cities.join(", ")}
                              </label>
                            </span>
                          </div>
                        ))}
                      </div>
                    )}

                    {remainingLocations.map((ele, index) => (
                      <div
                        className="gap-2 flex ml-4 items-baseline py-1"
                        key={index}
                      >
                        <input
                          type="checkbox"
                          checked={filterData.location.includes(ele.name)} // Check if the location is selected
                          onChange={(e) => handleCheckboxChangeLoc(e, ele)} // Handle checkbox change
                        />
                        <span className="flex flex-col px-1 cursor-pointer">
                          <label> {ele.name}</label>
                          <label className="opacity-50 pl-2">
                            {ele.cities.join(", ")}
                          </label>
                        </span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <div className="border rounded-md p-2 mt-2">
          <div
            className="flex justify-between items-center  rounded-md "
            onClick={() => relabilityToogle("reliability")}
            style={{
              cursor: "pointer",
              background: "white",
              padding: "2px",
            }}
          >
            <p className="mt-1 mb-1 text-[var(--heading-color)] font-bold">
              Reliability
            </p>
            <div>
              {reliabilitySection === "reliability" ? (
                <DropUpArrow />
              ) : (
                <DropDown />
              )}
            </div>
          </div>
          {reliabilitySection === "reliability" && (
            <div>
              <FormControl fullWidth size="small">
                <Select
                  inputProps={{
                    "aria-label": "Without label",
                    color: "#e5e7eb",
                  }}
                  displayEmpty
                  name="reliability"
                  value={filterData?.reliability || ""}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    const numericValue = value.split(" ")[0]; // Extract the number part, e.g., "4 Star" -> "4"

                    setFilterData((prevData) => ({
                      ...prevData,
                      [name]: numericValue, // Store only the number in state
                    }));
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <p className="text-[1rem] text-[var(--light-gray)]">
                          Choose reliability
                        </p>
                      );
                    }

                    // Render the value with "Star" for display
                    return `${selected} Star`;
                  }}
                >
                  <MenuItem value="5">5 Star</MenuItem>
                  <MenuItem value="4">4 Star</MenuItem>
                  <MenuItem value="3">3 Star</MenuItem>
                  <MenuItem value="2">2 Star</MenuItem>
                  <MenuItem value="1">1 Star</MenuItem>
                </Select>
              </FormControl>
            </div>
          )}
        </div>

        <div className="border rounded-md px-2 py-2 mt-2">
          <div
            className="flex justify-between items-center  rounded-md "
            onClick={() => distanceToogle("distance")}
            style={{
              cursor: "pointer",
              background: "white",
              padding: "2px",
            }}
          >
            <p className=" text-[var(--heading-color)] font-bold">Distance</p>
            <div>
              {distanceSection === "distance" ? <DropUpArrow /> : <DropDown />}
            </div>
          </div>

          {distanceSection === "distance" && (
            <CustomInput
              name="maxValueKms"
              placeholder="Enter Max Distance"
              //   title="Manpower"
              value={filterData?.maxValueKms}
              size="small"
              type="number"
              required
              onChange={(e) => {
                const value = e.target.value;
                if (
                  !value.startsWith(" ") &&
                  Number(value) >= 0 &&
                  Number(value) <= 500
                ) {
                  handleInputChange(e);
                }
              }}
              onKeyPress={(e) => handleKeyPress(e)}
              onFocus={(e) => {
                e.target.addEventListener(
                  "wheel",
                  (event) => {
                    event.preventDefault();
                  },
                  { passive: false },
                );
              }}
              onBlur={(e) => {
                e.target.removeEventListener("wheel", (event) => {
                  event.preventDefault();
                });
              }}
            />
          )}
        </div>
        <div className="border rounded-md px-2 py-2 mt-2">
          <div
            className="flex mb-1 justify-between items-center  rounded-md "
            onClick={() => creditToogle("credit")}
            style={{
              cursor: "pointer",
              background: "white",
              padding: "2px",
            }}
          >
            <p className=" text-[var(--heading-color)] font-bold">
              Assigned Credit Limit (Rs)
            </p>
            <div>
              {creditSection === "credit" ? <DropUpArrow /> : <DropDown />}
            </div>
          </div>
          {creditSection === "credit" && (
            <CustomInput
              name="creditLimit"
              placeholder="Enter Credit Limit"
              value={filterData?.creditLimit}
              size="small"
              type="number"
              required
              onChange={(e) => {
                const value = e.target.value;
                if (!value.startsWith(" ") && Number(value) >= 0) {
                  handleInputChange(e);
                }
              }}
              onKeyPress={(e) => handleKeyPress(e)}
              onFocus={(e) => {
                e.target.addEventListener(
                  "wheel",
                  (event) => {
                    event.preventDefault();
                  },
                  { passive: false },
                );
              }}
              onBlur={(e) => {
                e.target.removeEventListener("wheel", (event) => {
                  event.preventDefault();
                });
              }}
            />
          )}
        </div>
        <div className="border rounded-md px-2 py-2 mt-2">
          <div
            className="flex mb-1 justify-between items-center  rounded-md "
            onClick={() => manpowerToogle("manpower")}
            style={{
              cursor: "pointer",
              background: "white",
              padding: "2px",
            }}
          >
            <p className=" text-[var(--heading-color)] font-bold">Manpower</p>
            <div>
              {manpowerSection === "manpower" ? <DropUpArrow /> : <DropDown />}
            </div>
          </div>
          {manpowerSection === "manpower" && (
            <CustomInput
              name="manpower"
              placeholder="Enter Manpower"
              //   title="Manpower"
              value={filterData?.manpower}
              size="small"
              type="number"
              required
              onChange={(e) => {
                const value = e.target.value;
                if (!value.startsWith(" ") && Number(value) >= 0) {
                  handleInputChange(e);
                }
              }}
              //   onBlur={(e) => {
              //     if (saveButtonClicked) {
              //       validateForm();
              //     }
              //   }}
              onKeyPress={(e) => handleKeyPress(e)}
              onFocus={(e) => {
                e.target.addEventListener(
                  "wheel",
                  (event) => {
                    event.preventDefault();
                  },
                  { passive: false },
                );
              }}
              onBlur={(e) => {
                e.target.removeEventListener("wheel", (event) => {
                  event.preventDefault();
                });
              }}
            />
          )}
        </div>
        <div className="border rounded-md px-2 py-2 mt-2">
          <div>
            <div
              className="flex mb-1 justify-between items-center rounded-md"
              onClick={() => toggleSection("product")}
              style={{ cursor: "pointer", background: "white", padding: "2px" }}
            >
              <p className="text-[var(--heading-color)] font-bold">Products</p>
              <div>
                {openSection === "product" ? <DropUpArrow /> : <DropDown />}
              </div>
            </div>

            {openSection === "product" && (
              <div style={{ marginTop: "8px" }}>
                <FormControl fullWidth size="small" style={{ width: 300 }}>
                  <Select
                    multiple
                    value={filterData.selectedProducts || []}
                    onChange={(e) => {
                      setFilterData((prev) => ({
                        ...prev,
                        selectedProducts: e.target.value,
                      }));
                    }}
                    renderValue={(selected) =>
                      selected.length > 0
                        ? selected
                            .map((val) => {
                              const [, name] = val.split(":");
                              return name;
                            })
                            .join(", ")
                        : "Select products"
                    }
                    displayEmpty
                    inputProps={{ "aria-label": "Select products" }}
                  >
                    {productOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={
                            filterData.selectedProducts?.includes(
                              option.value,
                            ) || false
                          }
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            )}
          </div>
        </div>
        {/* certifications */}
        <div className="border rounded-md px-2 py-2 mt-2">
          <div>
            <div
              className="flex mb-1 justify-between items-center rounded-md"
              onClick={() => toggleCertSection("certifications")}
              style={{ cursor: "pointer", background: "white", padding: "2px" }}
            >
              <p className="text-[var(--heading-color)] font-bold">
                Certifications
              </p>
              <div>
                {opencertSection === "certifications" ? (
                  <DropUpArrow />
                ) : (
                  <DropDown />
                )}
              </div>
            </div>

            {opencertSection === "certifications" && (
              <div>
                <div
                  className="flex justify-between items-center border-2 rounded-md cursor-pointer px-2 py-1"
                  onClick={() => selectCertToogle("certificationsSelect")}
                  style={{ border: "1px solid var(--listdown-color)" }}
                >
                  <h2>Select Certificate</h2>
                  <div
                    className={`${
                      certSection === "certificationsSelect"
                        ? "hidden"
                        : "block"
                    } mr-3`}
                  >
                    <DropDown />
                  </div>
                </div>

                {certSection === "certificationsSelect" && (
                  <div
                    style={{
                      paddingLeft: "20px",
                      border: "1px solid var(--listdown-color)",
                      borderRadius: "5px",
                      marginTop: "2px",
                    }}
                  >
                    {["3M", "LG", "Avery"].map((cert) => (
                      <div key={cert} className="flex gap-2">
                        <input
                          type="checkbox"
                          checked={selectedCerts.includes(cert)}
                          onChange={() => handleCartCheckboxChange(cert)}
                        />
                        <label
                          style={{
                            display: "block",
                            cursor: "pointer",
                            padding: "2px 0",
                          }}
                        >
                          {cert}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {/* certifications end */}

        <div className="border rounded-md px-2 py-2 mt-2">
          <div
            className="flex mb-1 justify-between items-center  rounded-md "
            onClick={() => premisesToogle("premises")}
            style={{
              cursor: "pointer",
              background: "white",
              padding: "2px",
            }}
          >
            <p className=" text-[var(--heading-color)] font-bold">
              Area of premises (sqft.)
            </p>
            <div>
              {premisesSection === "premises" ? <DropUpArrow /> : <DropDown />}
            </div>
          </div>

          {premisesSection === "premises" && (
            <CustomInput
              name="premises"
              placeholder="Enter Area of Premises"
              //   title="Manpower"
              value={filterData?.premises}
              size="small"
              type="number"
              required
              onChange={(e) => {
                const value = e.target.value;
                if (!value.startsWith(" ") && Number(value) >= 0) {
                  handleInputChange(e);
                }
              }}
              //   onBlur={(e) => {
              //     if (saveButtonClicked) {
              //       validateForm();
              //     }
              //   }}
              onKeyPress={(e) => handleKeyPress(e)}
              onFocus={(e) => {
                e.target.addEventListener(
                  "wheel",
                  (event) => {
                    event.preventDefault();
                  },
                  { passive: false },
                );
              }}
              onBlur={(e) => {
                e.target.removeEventListener("wheel", (event) => {
                  event.preventDefault();
                });
              }}
            />
          )}
        </div>
        <div className="border rounded-md p-2 mt-2">
          <div className="flex gap-2 items-center">
            <input
              type="checkbox"
              value={useFabricationMachinesForFilter}
              checked={useFabricationMachinesForFilter}
              name="checkMachinesForFabrication"
              onChange={(e) => {
                handleInputChange(e);
                setUseFabricationMachinesForFilter(e.target.checked);
              }}
            />
            <div
              className="flex mb-1 w-full justify-between items-center rounded-md p-1/2 cursor-pointer bg-white"
              onClick={() => fabricationMachineToggle("fabrication")}
            >
              <p className=" text-[var(--heading-color)] font-bold">
                {`Machines Needed For Fabrication`}
              </p>
              <div>
                {fabricationMachineSection === "fabrication" ? (
                  <DropUpArrow />
                ) : (
                  <DropDown />
                )}
              </div>
            </div>
          </div>
          {fabricationMachineSection === "fabrication" && (
            <div>
              {machinesNeededForFabrication.map((machine, i) => (
                <div key={i}>
                  <span>{machine?.type}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="border rounded-md p-2 mt-2">
          <div className="flex gap-2 items-center">
            <input
              type="checkbox"
              name="checkMachinesForPrinting"
              value={usePrintingMachinesForFilter}
              checked={usePrintingMachinesForFilter}
              onChange={(e) => {
                handleInputChange(e);
                setUsePrintingMachinesForFilter(!usePrintingMachinesForFilter);
              }}
            />
            <div
              className="flex mb-1 w-full justify-between items-center rounded-md p-1/2 cursor-pointer bg-white"
              onClick={() => printingMachineToggle("printing")}
            >
              <p className=" text-[var(--heading-color)] font-bold">
                {`Machines Needed For Printing`}
              </p>
              <div>
                {printingMachineSection === "printing" ? (
                  <DropUpArrow />
                ) : (
                  <DropDown />
                )}
              </div>
            </div>
          </div>
          {printingMachineSection === "printing" && (
            <div>
              {machinesNeededForPrinting.map((machine, i) => (
                <div key={i}>
                  <span>{machine?.type}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="w-30">
          <GlobalButton variant="secondary" size="medium" onClick={handleClose}>
            {`Close`}
          </GlobalButton>
        </div>
        <div className="w-30">
          <GlobalButton
            type="submit"
            variant="primary"
            size="medium"
            isLoading={isRadarLoading}
            onClick={
              availableClusters.length == 0
                ? (e) => handleFilterClick(e)
                : (e) => {
                    handleSubmit(e);
                  }
            }
          >
            {availableClusters.length == 0 ? "Filter" : "Apply"}
          </GlobalButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default MapFilterModal;
